const USER_FACE_ACTIONS = {
  //GET FACE ACTION
  GET_FACE_USER_BY_ID: "GET_FACE_USER_BY_ID",
  GET_FACE_USER_BY_ID_SUCCESS: "GET_FACE_USER_BY_ID_SUCCESS",
  GET_FACE_USER_BY_ID_FAIL: "GET_FACE_USER_BY_ID_FAIL",

  //UPLOAD FACE ACTION
  UPLOAD_USER_FACE: "UPLOAD_USER_FACE",
  UPLOAD_USER_FACE_SUCCESS: "UPLOAD_USER_FACED_SUCCESS",
  UPLOAD_USER_FACE_FAIL: "UPLOAD_USER_FACE_FAIL",

  //DELETE FACE
  DELETE_USER_FACE: "DELETE_USER_FACE",
  DELETE_USER_FACE_SUCCESS: "DELETE_USER_FACE_SUCCESS",
  DELETE_USER_FACE_FAIL: "DELETE_USER_FACE_FAIL",

  SHOW_CROP_MODAL: "SHOW_CROP_MODAL",
  HIDE_CROP_MODAL: "HIDE_CROP_MODAL",
};
export default USER_FACE_ACTIONS;
